import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useSetRecoilState } from 'recoil';
import { logoUploadedAtom } from '../Atoms';

const sendFile = async (fileSize, fileType, fileName, fileAlreadyRead) => {
  const token = localStorage.getItem('access_token');
  const reqBody = JSON.stringify({
    // eslint-disable-next-line no-undef
    parents: [GDRIVE_FOLDER_ID],
    name: fileName,
  });
  fetch('https://www.googleapis.com/drive/v3/files', {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: reqBody,
  })
    .then((response) => response.json())
    .then((res) => {
      fetch(`https://www.googleapis.com/upload/drive/v3/files/${res.id}`, {
        //part 2 request with content
        method: 'PATCH',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': fileType,
          'Content-Length': fileSize,
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: fileAlreadyRead,
      }).then((res2) => console.log(res2));
    });
};

const UploadButton = function UploadButton() {
  const [file, setFile] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [fileSize, setFileSize] = useState(null);
  const [fileName, setFileName] = useState(null);
  let f;
  const setLogoUploaded = useSetRecoilState(logoUploadedAtom);
  useEffect(() => {
    if (file) {
      const abcd = file[0];
      f = abcd;
      const fr = new FileReader();

      fr.addEventListener(
        //vedi quando il reader ha letto e fai cose
        'load',
        () => {
          setFileType(f.type);
          setFileSize(f.size);
          setFileName(f.name);
          setFileData(fr.result);
        },
        false
      );
      fr.readAsArrayBuffer(f); //parte prima
    }
  }, [file]);

  useEffect(() => {
    if (fileData) {
      if (fileType)
        sendFile(fileSize, fileType, fileName, fileData).then((res) => {
          setLogoUploaded(true);
          console.log(res);
        });
    }
  }, [fileData]);

  return (
    <Button variant="contained" component="label">
      Upload File
      <input type="file" onChange={(e) => setFile(e.target.files)} hidden />
    </Button>
  );
};
export default UploadButton;
